{
  "Changelog": "Changelog",
  "Admin": "Admin",
  "Before": "Before",
  "After": "After",
  "Changes": "Changes",
  "Bugs": "Bugs",
  "Unfixed": "Unfixed",
  "Fixed": "Fixed",
  "Upcoming": "Upcoming",
  "addition": "Addition",
  "added": "Added",
  "changed": "Changed"
}
